import type { TasklistPageJson } from '@/types/tasklistPageJson';

export function parseTasklistPageFromWpPayload(raw: unknown): TasklistPageJson | null {
  if (raw == null || typeof raw !== 'object') return null;
  const r = raw as Record<string, unknown>;
  if (typeof r.title !== 'string' || !r.title.trim()) return null;

  const displayConditions =
    r.displayConditions && typeof r.displayConditions === 'object'
      ? (r.displayConditions as TasklistPageJson['displayConditions'])
      : { userRole: [], gradeBand: [] };

  const base: TasklistPageJson = {
    id: typeof r.id === 'string' ? r.id : undefined,
    slug: typeof r.slug === 'string' ? r.slug : undefined,
    title: r.title,
    taskType: typeof r.taskType === 'string' ? r.taskType : undefined,
    preview: typeof r.preview === 'string' ? r.preview : undefined,
    description: typeof r.description === 'string' ? r.description : undefined,
    displayConditions,
    content: Array.isArray(r.content) ? (r.content as TasklistPageJson['content']) : [],
    subtasks: Array.isArray(r.subtasks) ? (r.subtasks as TasklistPageJson['subtasks']) : [],
    keepLearning: r.keepLearning,
    featured: typeof r.featured === 'boolean' ? r.featured : undefined,
    isVisible: typeof r.isVisible === 'boolean' ? r.isVisible : undefined,
  };

  if (Array.isArray(r.wpSections)) {
    base.wpSections = r.wpSections as unknown[];
  }
  if (r.wpFaq && typeof r.wpFaq === 'object') {
    base.wpFaq = r.wpFaq as TasklistPageJson['wpFaq'];
  }

  return base;
}
